module.exports = __webpack_public_path__ + "media/pages/assets/images/refresh-c30b1a246b6ea0e40ab429dbc70208c7.png";